import { render } from "./coldCalls.vue?vue&type=template&id=758c0af6&scoped=true"
import script from "./coldCalls.vue?vue&type=script&lang=js"
export * from "./coldCalls.vue?vue&type=script&lang=js"

import "./coldCalls.vue?vue&type=style&index=0&id=758c0af6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758c0af6"]])

export default __exports__